import { api } from './api';
import {
  ListarHorariosResponse,
  SalvarMarcacoesRequest,
  HorarioOficialConfig,
  AtualizarConfigRequest,
  NotificacaoSubscription,
  RelatorioSemanalResponse,
  HistoricoRelatoriosResponse,
} from '../types/horariosOficiais';

/**
 * Lista todos os oficiais com suas marcações da semana atual
 */
export async function listarHorariosOficiais(): Promise<ListarHorariosResponse> {
  const response = await api.get('/horarios-oficiais');
  return response.data;
}

/**
 * Salva as marcações de horários para o oficial autenticado
 */
export async function salvarMarcacoes(data: SalvarMarcacoesRequest): Promise<void> {
  await api.post('/horarios-oficiais/marcacoes', data);
}

/**
 * Remove todas as marcações de um dia específico para o oficial autenticado
 */
export async function limparMarcacoes(data: string): Promise<void> {
  await api.delete(`/horarios-oficiais/marcacoes/${data}`);
}

/**
 * Obtém todas as configurações do sistema de horários
 */
export async function obterConfiguracoes(): Promise<HorarioOficialConfig[]> {
  const response = await api.get('/horarios-oficiais/config');
  return response.data;
}

/**
 * Atualiza uma configuração específica do sistema
 */
export async function atualizarConfiguracao(data: AtualizarConfigRequest): Promise<HorarioOficialConfig> {
  const response = await api.put('/horarios-oficiais/config', data);
  return response.data;
}

/**
 * Registra a subscription para receber notificações push
 */
export async function registrarNotificacao(subscription: NotificacaoSubscription): Promise<void> {
  await api.post('/horarios-oficiais/notificacoes/subscribe', subscription);
}

/**
 * Desativa as notificações push para o militar autenticado
 */
export async function desativarNotificacao(): Promise<void> {
  await api.delete('/horarios-oficiais/notificacoes/unsubscribe');
}

/**
 * Obtém o relatório da semana atual
 */
export async function obterRelatorioSemanal(): Promise<RelatorioSemanalResponse> {
  const response = await api.get('/horarios-oficiais/relatorios/semanal');
  return response.data;
}

/**
 * Obtém o histórico de relatórios semanais paginado
 */
export async function obterHistoricoRelatorios(
  pagina: number = 1,
  limite: number = 10
): Promise<HistoricoRelatoriosResponse> {
  const response = await api.get('/horarios-oficiais/relatorios/historico', {
    params: { page: pagina, limit: limite },
  });
  return response.data;
}

/**
 * Obtém os detalhes de um relatório de uma semana específica
 */
export async function obterDetalhesRelatorio(semanaInicio: string): Promise<RelatorioSemanalResponse> {
  const response = await api.get(`/horarios-oficiais/relatorios/${semanaInicio}`);
  return response.data;
}

// Exportar todas as funções como objeto default
export const horariosOficiaisService = {
  listarHorariosOficiais,
  salvarMarcacoes,
  limparMarcacoes,
  obterConfiguracoes,
  atualizarConfiguracao,
  registrarNotificacao,
  desativarNotificacao,
  obterRelatorioSemanal,
  obterHistoricoRelatorios,
  obterDetalhesRelatorio,
};
